module.exports = __webpack_public_path__ + "static/media/dicacvv.d787b3e2.png";